export default __webpack_public_path__ + "static/CynosureCapitalMGMT_Logo_White-eff7f637bb554a0a3ce031eee61d40ef.png";